import React from "react";
import "./style.css";

const NoResultFound = ({ heading }) => {
  return (
    <div className="no_events">
      <p>{heading}</p>
    </div>
  );
};

export default NoResultFound;
